if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';

        this.superSaverEnabled = this.dataset.superSaverEnabled === 'true';
        this.superSaverModalId = this.dataset.superSaverModal;
        if (this.superSaverEnabled && this.superSaverModalId) {
          this.initSuperSaver();
        }
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        if (this.shouldBypassSuperSaver) {
          this.shouldBypassSuperSaver = false;
        } else if (this.superSaverModal) {
          this.openSuperSaverModal();
          this.resetSubmitState();
          return;
        }

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;
console.log(formData.get('quantity'));
        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            const startMarker = CartPerformance?.createStartingMarker('add:wait-for-subscribers');
            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              }).then(() => {
                CartPerformance?.measureFromMarker('add:wait-for-subscribers', startMarker);
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    CartPerformance?.measure("add:paint-updated-sections", () => {
                      this.cart.renderContents(response);
                    });
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              CartPerformance?.measure("add:paint-updated-sections", () => {
                this.cart.renderContents(response);
              });
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');

            CartPerformance?.measureFromEvent("add:user-action", evt);
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      initSuperSaver() {
        this.superSaverModal = document.getElementById(this.superSaverModalId);
        if (!this.superSaverModal) return (this.superSaverEnabled = false);

        const m = this.superSaverModal;
        this.superSaverVariantButtons = m.querySelectorAll('[data-super-saver-variant]');
        this.superSaverConfirmButton = m.querySelector('[data-super-saver-confirm]');
        this.superSaverError = m.querySelector('[data-super-saver-error]');
        this.superSaverQuantityEl = m.querySelector('[data-super-saver-quantity]');
        this.superSaverTotalEl = m.querySelector('[data-super-saver-total]');
        this.superSaverButtonText = m.querySelector('[data-super-saver-button-text]');
        this.superSaverButtonSummary = m.querySelector('[data-super-saver-button-summary]');
        this.superSaverMainPrice = parseFloat(this.superSaverConfirmButton?.getAttribute('data-super-saver-main-price') || 0);
        this.superSaverSelected = new Map();
        this.shouldBypassSuperSaver = false;
        this.superSaverSwipers = new Map();

        this.superSaverVariantButtons.forEach((btn) => {
          btn.addEventListener('click', () => {
            const vId = btn.getAttribute('data-super-saver-variant');
            const price = parseFloat(btn.getAttribute('data-super-saver-price') || 0);
            const productContainer = btn.closest('.super-saver-product');
            const isSelected = this.superSaverSelected.has(vId);
            if (isSelected) {
              this.superSaverSelected.delete(vId);
              btn.classList.remove('is-selected');
              btn.setAttribute('aria-pressed', 'false');
              btn.textContent = btn.dataset.defaultLabel || 'ADD +';
              productContainer?.classList.remove('active');
            } else {
              this.superSaverSelected.set(vId, price);
              btn.classList.add('is-selected');
              btn.setAttribute('aria-pressed', 'true');
              btn.textContent = btn.dataset.selectedLabel || 'Added';
              productContainer?.classList.add('active');
            }
            this.updateSuperSaverSummary();
          });
        });

        m.querySelectorAll('[data-super-saver-close]').forEach((btn) => {
          btn.addEventListener('click', () => {
            this.toggleSuperSaverModal(false);
            this.resetSubmitState();
          });
        });

        this.superSaverConfirmButton?.addEventListener('click', () => this.handleSuperSaverConfirm());
      }

      toggleSuperSaverModal(open) {
        if (!this.superSaverModal) return;
        this.superSaverModal.classList.toggle('is-visible', open);
        this.superSaverModal.setAttribute('aria-hidden', !open);
        document.body.classList.toggle('overflow-hidden', open); 
      }

      openSuperSaverModal() {
        this.toggleSuperSaverModal(true);
        if (this.superSaverTotalEl && this.superSaverMainPrice) {
          this.superSaverTotalEl.innerHTML = this.formatMoney(this.superSaverMainPrice);
        }
        if (this.superSaverQuantityEl) {
          this.superSaverQuantityEl.textContent = '0';
        }
        if (this.superSaverButtonSummary) {
          this.superSaverButtonSummary.textContent = '';
        }
        this.updateSuperSaverSummary();
        setTimeout(() => this.initSuperSaverSwipers(), 100);
      }

      initSuperSaverSwipers() {
        if (typeof Swiper === 'undefined') return;
        const swiperContainers = this.superSaverModal?.querySelectorAll('[data-super-saver-swiper]');
        if (!swiperContainers) return;
        
        swiperContainers.forEach((container) => {
          const id = container.getAttribute('data-super-saver-swiper');
          if (this.superSaverSwipers.has(id)) {
            this.superSaverSwipers.get(id).destroy(true, true);
          }
          const swiper = new Swiper(container, {
            slidesPerView: 1,
            spaceBetween: 10,
            pagination: {
              el: container.querySelector('.swiper-pagination'),
              clickable: true,
            },
            loop: false,
          });
          this.superSaverSwipers.set(id, swiper);
        });
      }
      closeSuperSaverModal() {
        this.toggleSuperSaverModal(false);
        this.superSaverSwipers.forEach((swiper) => swiper.destroy(true, true));
        this.superSaverSwipers.clear();
      }

      updateSuperSaverSummary() {
        const qty = this.superSaverSelected.size;
        const comboTotal = Array.from(this.superSaverSelected.values()).reduce((sum, price) => sum + price, 0);
        const total = (this.superSaverMainPrice || 0) + comboTotal;
        
        if (this.superSaverQuantityEl) {
          this.superSaverQuantityEl.textContent = qty;
        }
        
        if (this.superSaverTotalEl) {
          this.superSaverTotalEl.innerHTML = this.formatMoney(total);
        }
        
        if (this.superSaverButtonSummary) {
          if (qty > 0) {
            const mainQty = 1;
            const totalQty = mainQty + qty;
            this.superSaverButtonSummary.textContent = ` (${totalQty}) - ${this.formatMoney(total)}`;
          } else {
            this.superSaverButtonSummary.textContent = '';
          }
        }
      }

      formatMoney(cents) {
        const rupees = Math.floor(cents / 100);
        const paise = cents % 100;
        return `₹${rupees}${paise > 0 ? '.' + String(paise).padStart(2, '0') : ''}`;
      }

      resetSubmitState() {
        this.submitButton.classList.remove('loading');
        this.submitButton.removeAttribute('aria-disabled');
        this.submitButton.querySelector('.loading__spinner')?.classList.add('hidden');
      }

      async handleSuperSaverConfirm() {
        if (this.superSaverProcessing) return;
        this.superSaverProcessing = true;
        this.superSaverError && (this.superSaverError.hidden = true);
        const btn = this.superSaverConfirmButton;
        btn?.setAttribute('disabled', 'disabled');
        btn?.classList.add('loading');

        try {
          if (this.superSaverSelected.size > 0) {
            const res = await fetch('/cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
              body: JSON.stringify({
                items: Array.from(this.superSaverSelected.keys()).map((vId) => ({
                  id: vId,
                  quantity: 1,
                }))
              })
            });
            if (!res.ok) throw new Error('Unable to add selected products.');
            this.superSaverSelected.clear();
            this.superSaverVariantButtons.forEach((b) => {
              b.classList.remove('is-selected');
              b.setAttribute('aria-pressed', 'false');
              b.textContent = b.dataset.defaultLabel || 'ADD +';
              b.closest('.super-saver-product')?.classList.remove('active');
            });
            this.updateSuperSaverSummary();
          }
          this.shouldBypassSuperSaver = true;
          this.toggleSuperSaverModal(false);
          this.form.requestSubmit();
        } catch (e) {
          if (this.superSaverError) {
            this.superSaverError.textContent = e.message || 'Unable to add selected products. Please try again.';
            this.superSaverError.hidden = false;
          }
        } finally {
          this.superSaverProcessing = false;
          btn?.removeAttribute('disabled');
          btn?.classList.remove('loading');
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}
